<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <template slot="field">
      <div v-if="field.route" class="">

        <b-card class="">
            <div class="bottom-button-cover">
              <div class="">

                <div v-if="showTrialInfo" style="margin-top: 15px">
                  <p v-if="field.trialText">{{ $t(field.trialText) }}</p>
                  <p v-if="$settings.trial_ends_at" class="text-danger" style="font-weight: 600">
                    {{ $t('attributes.settings.connect_google_account.trial_ends_at') }}: {{ formattedEndDate }}
                    <span v-if="countdown"> ({{ countdown }})</span>
                  </p>
                </div>
              </div>
              <div>
                <button type="button" class="btn btn-primary" @click="$router.push('/'+field.route)">
                  <i class="icon-google mr-2"></i>
                  {{ field.label }}
                </button>
              </div>
            </div>
        </b-card>

        <p v-if="field.afterText" style="margin-top: 15px" v-html="$t(field.afterText)"></p>

      </div>
    </template>
  </component>
</template>

<script>
import { FormTextField } from 'stylemix-base'

export default {
  name: 'ButtonField',
  extends: FormTextField,

  data () {
    return {
      countdownInterval: null,
      now: Date.now()
    }
  },

  computed: {
    showTrialInfo () {
      return this.$settings && this.$settings.trial_ends_at
    },
    trialEndsAt () {
      return this.$settings?.trial_ends_at ? new Date(this.$settings.trial_ends_at) : null
    },
    trialTextWithCountdown () {
      if (!this.field.trialText) return ''
      const placeholder = this.countdown || this.formattedEndDate
      return this.field.trialText.replace('%s', placeholder)
    },
    formattedEndDate () {
      if (!this.trialEndsAt) return ''
      return this.trialEndsAt.toLocaleString(this.$i18n?.locale || 'en', {
        dateStyle: 'medium',
        timeStyle: 'short'
      })
    },
    countdown () {
      if (!this.trialEndsAt) return ''
      const diff = this.trialEndsAt.getTime() - this.now
      if (diff <= 0) return this.$t('attributes.settings.connect_google_account.trial_expired') || 'Expired'
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const parts = []
      if (days > 0) parts.push(`${days}d`)
      if (hours > 0) parts.push(`${hours}h`)
      if (minutes > 0 || parts.length === 0) parts.push(`${minutes}m`)
      return parts.join(' ')
    }
  },

  mounted () {
    if (this.showTrialInfo) {
      this.countdownInterval = setInterval(() => {
        this.now = Date.now()
      }, 1000)
    }
  },

  beforeDestroy () {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  }
}
</script>

